import { usePartnerConfig } from '~/stores/usePartnerConfig';
import { LandingType } from '~/enums/LandingType';

export default defineNuxtRouteMiddleware((to, from) => {
  const { landing } = usePartnerConfig();

  const hasGeoComponent = computed(() => {
    switch (landing.value) {
      case LandingType.SX:
        return false;
      case LandingType.BLACKPROXY:
        return false;
      case LandingType.AKENET:
        return false;
      case LandingType.NEXUS:
        return false;
      case LandingType.ANYPAGE:
        return false;
      case LandingType.ASOCKS:
        return true;
      default:
        return false;
    }
  })

  // if (!hasGeoComponent.value) {
  //   return navigateTo('/')
  // }
})